import React from 'react'
import { Button, Table, Container, Row, Col, Label, Input } from 'reactstrap'
import '../css/QuoteViewController.css'
import { getCustomerNames } from '../model/request/quotes'
import DropDownTextField from '../view/DropDownTextField'
import {
    getBanks,
    removePrivateBankInfo,
} from '../model/request/bank'

class AdminBanksViewController extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            'company_name': '',
            'suggested_company_names': [],
            'banks': [],
            'private_key': '',
        }
    }

    updateCompanyDropDown(customerName) {
        if (customerName.length > 1) {
            getCustomerNames(customerName)
            .then(
                (result) => {
                    this.setState({
                        'suggested_company_names': result.data.customer_names
                    })
                },
                (error) => {
                    this.props.showError(error)
                }
            )
        } else {
            this.setState({
                'suggested_company_names': [],
            })
        }
    }

    removeBankInfo(id) {
        this.props.turnOffLoader()
        removePrivateBankInfo(id).then(
            (success) => {
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    searchBanks() {
        this.props.turnOffLoader()
        getBanks(
            this.state.company_name === '' ? 'all' : this.state.company_name,
            this.state.private_key,
        ).then(
            (banks) => {
                this.setState({
                    'banks': banks
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            },
        )
    }

    renderLabelBody(label, body) {
        return <>
            <Row>
            <Col><Label
                style={{
                    'fontSize': '18pt',
                    'fontWeight': '400',
                }}
            >{label}</Label>
            </Col>
        </Row>
        <Row>
            {body}
        </Row>
        </>
    }

    renderHeaderLabelAndBody(label, body) {
        return <>
        <Row>
            <Col><Label
                style={{
                    'fontSize': '16pt',
                    'fontWeight': '350',
                }}
            >{label}</Label></Col>
        </Row>
        <Row>
            <Col>{body}</Col>
        </Row>
        </>
    }

    renderInput(varname) {
        return <Input
            type='text'
            value={this.state[varname]}
            onChange={(e) => {
                const newState = {}
                newState[varname] = e.target.value
                this.setState(newState)
            }}
            />
    }

    renderBanks() {
        return this.state.banks.map((bank) => {
            return <tr>
                <td><Label>{bank.company}</Label></td>
                <td><Label>{bank.nick_name}</Label></td>
                <td><Label>{bank.account_number}</Label></td>
                <td><Label>{bank.account_title}</Label></td>
                <td><Label>{bank.ada_routing_number}</Label></td>
                <td><Button
                    color='danger'
                    onClick={() => {
                        this.removeBankInfo(bank.id)
                    }}
                >Remove Info</Button></td>
            </tr>
        })
    }

    render() {
        return <Container>
            <Row><Col>
                <Container
                    style={{
                        'maxWidth': '500px',
                        'marginLeft': '0px',
                    }}
                >
                {this.renderLabelBody('Company',
                    <>
                    <Row><Col>
                    <DropDownTextField
                        value={this.state.company_name}
                        values={this.state.suggested_company_names}
                        onChange={(e) => {
                            this.setState({
                                'company_name': e.target.value,
                            })
                            this.updateCompanyDropDown(e.target.value)
                        }}
                        onClickRow={(value, index) => {
                            this.setState({
                                'company_name': value,
                            })
                            this.updateCompanyDropDown(value)
                        }} />
                    </Col></Row>
                    </>
                )}
            </Container>
            <Container>
                {this.renderLabelBody('Private Key',
                    <>
                    <Row
                        style={{
                            'marginTop': '12px',
                        }}
                    ><Col>
                    <Input
                        type="textarea"
                        style={{
                            'maxWidth': '800px',
                            'height': '700px',
                        }}
                        value={this.state.private_key}
                        onChange={(e) => this.setState({'private_key': e.target.value})}
                        />
                    </Col></Row>
                    <Row
                        style={{
                            'marginTop': '12px',
                        }}
                    ><Col>
                    <Button
                        color='success'
                        onClick={() => {
                            this.searchBanks()
                        }}
                    >Search</Button>
                    </Col></Row>
                    </>
                )}
                </Container>
            </Col></Row>
            <Row><Col><Container style={{'overflowX': 'auto'}}><Table>
                <thead>
                    <tr>
                        <th className="text-center label-weight"
                            style={{'minWidth': '130px'}}>Company</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '130px'}}>Nick Name</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '130px'}}>Account Number</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '130px'}}>Account Title</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '150px'}}>Ada Routing Number</th>
                    </tr>
                </thead>
                <tbody>
                    {this.renderBanks()}
                </tbody>
            </Table></Container></Col></Row>
        </Container>
    }
}

export default AdminBanksViewController;
